module.exports = __webpack_public_path__ + "img/mediator-diplomat-3.4d4f06f0.svg";